/**
 * IMPORTANT! Do not use any services/composables here! (other than the ones defined in the context).
 *
 * This redirect handler should be used solely to determine whether user should be redirected
 * to a certain place or not, based on the application state, which is passed into the exported
 * function as first argument.
 *
 * Only imports that help to determine the redirect are allowed here (like consts or moment).
 */

import { BUSINESS_PACKAGE } from '@/components/onboarding/consts.js'

import { replaceWithResolvedRoute } from '../utils/replace-with-resolved-route.js'

// TODO check if we still need this
export const merchantPackageRedirect = ({ query, params, store, router, logger }) => {
  if (store.getters['business/business'].package === BUSINESS_PACKAGE.Unknown) {
    logger.debug(`merchant package check fail! >>> merchant-package-check`)
    return replaceWithResolvedRoute(router, { name: 'merchant-package-check', query, params })
  }
}
